import { useEffect, useState } from 'react';
import { listLanguageSkills } from '../../../api';
import { LanguageSkill } from '../../../types/language';

export function usePublishedLanguageSkills() {
  const [langSkills, setLangSkills] = useState<LanguageSkill[]>([]);
  const [langSkillsLoading, setLangSkillsLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLangSkillsLoading(true);
    listLanguageSkills({ status: 'published' })
      .then(data => { if (!cancelled) setLangSkills(data || []); })
      .catch(() => { if (!cancelled) setLangSkills([]); })
      .finally(() => { if (!cancelled) setLangSkillsLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { langSkills, langSkillsLoading };
}
